import React from "react";
import { Typography, Container } from "@mui/material";

const GeneralEmergencyCare = () => {
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom sx={{ color: '#ED1C24' }}>
        General & Emergency Care
      </Typography>

      <Typography variant="body1" paragraph>
        At VEM Plus Urgent Care, we provide prompt and effective treatment for a wide range of
        non life threatening medical issues, ensuring you receive the right care when you need it most.
        Our <strong>General & Emergency Care</strong> services bridge the gap between primary care clinics
        and hospital emergency rooms, offering immediate attention without long wait times or high costs.
      </Typography>

      <Typography variant="body1" paragraph>
        Our facility is fully equipped to diagnose and treat common illnesses, minor injuries, and urgent
        medical concerns for patients of all ages from children to seniors. With extended operating hours,
        including evenings and weekends, we make quality healthcare more accessible and convenient.
      </Typography>

      <Typography variant="body2"component="ul"gutterBottom sx={{ pl: 3, listStyleType: 'disc', marginBottom: '0.5rem' }}>
        <li>Evaluation and treatment for <strong>chest pain</strong> and <strong>breathing difficulties</strong></li>
        <li>Care for <strong>minor fractures, sprains, and dislocations</strong></li>
        <li>Treatment for <strong>infections, fevers, and flu like symptoms</strong></li>
        <li>Management of <strong>stomach pain, nausea, and vomiting</strong></li>
        <li>First aid for <strong>burns, cuts, and lacerations</strong></li>
        <li>Assistance for <strong>allergic reactions and insect bites</strong></li>
        <li>On site <strong>X-rays and lab tests</strong> for quick diagnosis</li>
      </Typography>

      <Typography variant="body1" paragraph>
        All treatments are handled by experienced healthcare professionals who are committed to
        delivering compassionate and personalized care. Our goal is to stabilize your condition,
        relieve discomfort, and guide you toward full recovery as quickly as possible.
      </Typography>

      <Typography variant="body1" paragraph>
        Whether it’s a sudden illness, an unexpected injury, or an urgent medical concern, VEM Plus
        Urgent Care is here to provide efficient, affordable, and reliable healthcare exactly when
        you need it.
      </Typography>
    </Container>
  );
};


export default GeneralEmergencyCare;
